
import styled, { createGlobalStyle } from 'styled-components';

import { useState, useEffect } from 'preact/hooks';

import { JSONCrush, JSONUncrush } from 'jsoncrush';

import data from '../data';

import {
	Wrapper, Container, Header, House, Roof, Triangle,
	InnerContent, Page, Heading, List, ListItems, ListItem,
	Icons, Icon, Text, Button, Question, YellowText,
	TaskHeading, TaskNote, Instructions, Instruction, ResultsPageWrapper,
	ResultItemWrapper,ResultImage, ShareButton, ResultText, OutlineButton, HeadingWrapper, Link

} from './style';


import Button6Months from '../assets/buttons/6months.svg';
import Button12Months from '../assets/buttons/12months.svg';
import Button2Years from '../assets/buttons/2years.svg';
import Button5Years from '../assets/buttons/5years.svg';
import Button10Years from '../assets/buttons/10years.svg';
import ButtonNever from '../assets/buttons/none.svg';
import TickImage from '../assets/tick.png';
import CrossImage from '../assets/cross.png';
import UnknownImage from '../assets/unknown.png';


import IconOverdue from '../assets/icon-overdue.svg';
import IconUpToDate from '../assets/icon-up-to-date.svg';
import IconUnknown from '../assets/icon-unknown.svg';
import LogoImage from '../assets/logo.png';
import HeaderHomepage from '../assets/header-homepage.svg';
import HeaderResultsPage from '../assets/header-results.svg';



import { useSpring, animated, interpolate, useTransition } from 'react-spring'

const GlobalStyle = createGlobalStyle`
 

  html {
	  height:100%;
  }
  body {
	  min-height:100%;
  }
  body, html {
	  padding:0;
	  margin:0;
  }
  #app {
		height: 100%;
	}

	a {
		color:#fff;
	}
`;

/**
 * Only use this for non-user generated content.
 */
const InlineHTML = styled.span`

`;


const Progress = ({ currentStep, goToStep }) => {

	const steps = [];

	for (let i=0;i<data.length;i++) {
		steps.push(<ListItem active={currentStep >= i} >{ i+1 }</ListItem>)
	}

	return (
		<List>
			<ListItems>
				{ steps }
			</ListItems>
		</List>
	)
}


const AnswerPanelButton = ({ period }) => {

	const [animToggle, setAnimToggle] = useState(true);

	const props = useSpring({
		fill: animToggle ? 'rgb(0,0,0)' : 'rgb(255,223,67)', 
		opacity: animToggle ? 0.300000012 : 1,
		// reset: true,
		// reverse: true
	});


	const animate = () => {
		setAnimToggle(!animToggle);

		setTimeout(() =>  {
			setAnimToggle(true);
		}, 500);
	}

	
	const numbers = {
		// 2 years
		24: (<path d="M64.610816,73.74368 C64.9578667,73.74368 65.7387307,73.4895893 66.953408,72.981408 C68.1680853,72.4732267 69.11008,72.219136 69.779392,72.219136 C70.5478613,72.219136 72.531008,72.6901333 75.728832,73.632128 C75.580096,72.7645013 75.0843093,71.9464533 74.241472,71.177984 C73.7704747,70.731776 72.977216,70.1616213 71.861696,69.46752 C73.9192107,68.4511573 75.61728,67.2984533 76.955904,66.009408 C78.740736,64.298944 79.633152,62.5389013 79.633152,60.72928 C79.633152,57.9528747 78.2449493,56.564672 75.468544,56.564672 C73.8076587,56.564672 72.196352,56.8125653 70.634624,57.308352 C68.5275307,57.977664 67.473984,58.944448 67.473984,60.208704 C67.473984,60.803648 67.7590613,61.10112 68.329216,61.10112 C68.8993707,61.10112 70.2503893,60.5929387 72.382272,59.576576 C73.3242667,59.130368 74.1794987,58.907264 74.947968,58.907264 C76.6336427,58.907264 77.47648,59.7005227 77.47648,61.28704 C77.47648,62.848768 75.8651733,64.7327573 72.64256,66.939008 C69.890944,68.8229973 67.5731413,70.0128853 65.689152,70.508672 C64.648,70.7813547 64.0654507,70.9424853 63.941504,70.992064 C63.123456,71.3143253 62.714432,71.7853227 62.714432,72.405056 C62.714432,73.297472 63.34656,73.74368 64.610816,73.74368 Z" id="2" stroke="#2350A0" stroke-width="1.6" fill="#2350A0" fill-rule="nonzero"></path>),
		12: (<path d="M63.90432,73.37184 C64.2265813,73.3966293 65.01984,73.2726827 66.284096,73 C65.9618347,71.5622187 65.800704,69.9385173 65.800704,68.128896 C65.800704,67.3356373 65.912256,65.302912 66.13536,62.03072 C66.2345173,60.5929387 66.284096,59.3782613 66.284096,58.386688 C66.284096,57.6925867 66.209728,57.1968 66.060992,56.899328 C65.837888,56.4779093 65.4040747,56.2672 64.759552,56.2672 L64.759552,56.2672 L64.536448,56.2672 L63.978688,56.82496 C63.606848,57.1968 63.420928,57.4446933 63.420928,57.56864 C63.420928,57.6925867 63.4890987,57.8909013 63.62544,58.163584 C63.7617813,58.4362667 63.829952,58.6345813 63.829952,58.758528 C63.829952,59.2295253 63.774176,59.948416 63.662624,60.9152 C63.551072,61.881984 63.495296,62.6008747 63.495296,63.071872 C63.495296,65.897856 63.4333227,67.757056 63.309376,68.649472 L63.309376,68.649472 L62.97472,71.029248 C62.8507733,71.921664 62.7888,72.6777387 62.7888,73.297472 L62.7888,73.297472 L63.90432,73.37184 Z M70.094912,73.74368 C70.4419627,73.74368 71.2228267,73.4895893 72.437504,72.981408 C73.6521813,72.4732267 74.594176,72.219136 75.263488,72.219136 C76.0319573,72.219136 78.015104,72.6901333 81.212928,73.632128 C81.064192,72.7645013 80.5684053,71.9464533 79.725568,71.177984 C79.2545707,70.731776 78.461312,70.1616213 77.345792,69.46752 C79.4033067,68.4511573 81.101376,67.2984533 82.44,66.009408 C84.224832,64.298944 85.117248,62.5389013 85.117248,60.72928 C85.117248,57.9528747 83.7290453,56.564672 80.95264,56.564672 C79.2917547,56.564672 77.680448,56.8125653 76.11872,57.308352 C74.0116267,57.977664 72.95808,58.944448 72.95808,60.208704 C72.95808,60.803648 73.2431573,61.10112 73.813312,61.10112 C74.3834667,61.10112 75.7344853,60.5929387 77.866368,59.576576 C78.8083627,59.130368 79.6635947,58.907264 80.432064,58.907264 C82.1177387,58.907264 82.960576,59.7005227 82.960576,61.28704 C82.960576,62.848768 81.3492693,64.7327573 78.126656,66.939008 C75.37504,68.8229973 73.0572373,70.0128853 71.173248,70.508672 C70.132096,70.7813547 69.5495467,70.9424853 69.4256,70.992064 C68.607552,71.3143253 68.198528,71.7853227 68.198528,72.405056 C68.198528,73.297472 68.830656,73.74368 70.094912,73.74368 Z" id="12" stroke="#2350A0" stroke-width="1.6" fill="#2350A0" fill-rule="nonzero"></path>),
		6: (<path d="M70.221632,74.424896 C73.0971947,74.424896 75.6381013,73.867136 77.844352,72.751616 C80.6455467,71.338624 82.046144,69.3554773 82.046144,66.802176 C82.046144,64.6950827 81.116544,63.641536 79.257344,63.641536 C76.877568,63.641536 75.0059733,64.5091627 73.64256,66.244416 C72.4278827,67.7813547 71.7585707,69.776896 71.634624,72.23104 C71.2875733,72.6276693 70.7669973,72.825984 70.072896,72.825984 C69.0565333,72.825984 68.1889067,72.4293547 67.470016,71.636096 C66.7511253,70.8428373 66.39168,69.9380267 66.39168,68.921664 C66.39168,67.6326187 67.32128,65.984128 69.18048,63.976192 C71.6594133,61.3485227 73.382272,59.5389013 74.349056,58.547328 C76.1834667,56.6385493 77.100672,55.2627413 77.100672,54.419904 C77.100672,53.4283307 76.6296747,52.932544 75.68768,52.932544 C75.167104,52.932544 74.6713173,53.1680427 74.20032,53.63904 L74.20032,53.63904 L70.296,59.03072 C69.403584,60.0470827 68.2756693,61.224576 66.912256,62.5632 C66.01984,63.4308267 65.2885547,64.4719787 64.7184,65.686656 C64.0986667,66.9757013 63.7888,68.2027733 63.7888,69.367872 C63.7888,72.7392213 65.9330773,74.424896 70.221632,74.424896 Z M75.167104,71.67328 C74.2498987,71.67328 73.791296,71.3138347 73.791296,70.594944 C73.791296,69.7273173 74.3552533,68.754336 75.483168,67.676 C76.6110827,66.597664 77.621248,66.058496 78.513664,66.058496 C79.4556587,66.058496 79.926656,66.4427307 79.926656,67.2112 C79.926656,68.177984 79.3750933,69.16336 78.271968,70.167328 C77.1688427,71.171296 76.133888,71.67328 75.167104,71.67328 Z" id="6" stroke="#2350A0" stroke-width="1.6" fill="#2350A0" fill-rule="nonzero"></path>),
		60: (<path d="M69.861696,73.751616 C71.5225813,73.751616 73.133888,73.23104 74.695616,72.189888 C76.4308693,71.0495787 77.298496,69.69856 77.298496,68.136832 C77.298496,66.2528427 76.6167893,64.976192 75.253376,64.30688 C74.3857493,63.8854613 72.8859947,63.6499627 70.754112,63.600384 C68.4982827,63.5508053 67.035712,63.414464 66.3664,63.19136 C67.1348693,61.5800533 68.59744,60.3777707 70.754112,59.584512 C73.4065707,58.6425173 75.253376,58.0103893 76.294528,57.688128 C78.1041493,57.0436053 79.00896,56.1883733 79.00896,55.122432 C79.00896,54.8001707 78.82304,54.5026987 78.4512,54.230016 C77.9554133,53.858176 77.670336,53.6226773 77.595968,53.52352 L77.595968,53.52352 L77.261312,53.560704 C76.1705813,55.345536 74.4601173,56.6717653 72.12992,57.539392 C70.865664,58.0103893 68.6842027,58.4937813 65.585536,58.989568 C64.9658027,60.0802987 64.544384,60.9107413 64.32128,61.480896 C63.6023893,62.893888 63.242944,63.786304 63.242944,64.158144 C63.242944,65.199296 64.284096,65.719872 66.3664,65.719872 C66.7630293,65.719872 67.7546027,65.571136 69.34112,65.273664 C70.010432,65.1497173 70.605376,65.087744 71.125952,65.087744 C71.9687893,65.087744 72.7868373,65.3232427 73.580096,65.79424 C74.4973013,66.3396053 74.955904,67.0089173 74.955904,67.802176 C74.955904,68.9672747 74.17504,69.9712427 72.613312,70.81408 C71.2994773,71.5081813 70.010432,71.855232 68.746176,71.855232 C68.0520747,71.855232 66.3911893,71.4957867 63.76352,70.776896 C62.6232107,70.4546347 61.6316373,70.293504 60.7888,70.293504 C60.7888,71.4338133 62.0406613,72.338624 64.544384,73.007936 C66.3787947,73.5037227 68.151232,73.751616 69.861696,73.751616 Z" id="5" stroke="#2350A0" stroke-width="1.6" fill="#2350A0" fill-rule="nonzero"></path>),
		120: (<path d="M63.90432,71.37184 C64.2265813,71.3966293 65.01984,71.2726827 66.284096,71 C65.9618347,69.5622187 65.800704,67.9385173 65.800704,66.128896 C65.800704,65.3356373 65.912256,63.302912 66.13536,60.03072 C66.2345173,58.5929387 66.284096,57.3782613 66.284096,56.386688 C66.284096,55.6925867 66.209728,55.1968 66.060992,54.899328 C65.837888,54.4779093 65.4040747,54.2672 64.759552,54.2672 L64.759552,54.2672 L64.536448,54.2672 L63.978688,54.82496 C63.606848,55.1968 63.420928,55.4446933 63.420928,55.56864 C63.420928,55.6925867 63.4890987,55.8909013 63.62544,56.163584 C63.7617813,56.4362667 63.829952,56.6345813 63.829952,56.758528 C63.829952,57.2295253 63.774176,57.948416 63.662624,58.9152 C63.551072,59.881984 63.495296,60.6008747 63.495296,61.071872 C63.495296,63.897856 63.4333227,65.757056 63.309376,66.649472 L63.309376,66.649472 L62.97472,69.029248 C62.8507733,69.921664 62.7888,70.6777387 62.7888,71.297472 L62.7888,71.297472 L63.90432,71.37184 Z M74.222336,76.428864 C78.6596267,76.428864 82.4523947,74.8051627 85.60064,71.55776 C88.7488853,68.3103573 90.323008,64.455616 90.323008,59.993536 C90.323008,58.0847573 89.4925653,56.5602133 87.83168,55.419904 C86.34432,54.4035413 84.6090667,53.89536 82.62592,53.89536 C80.8162987,53.89536 78.7463893,54.899328 76.416192,56.907264 C74.5322027,58.54336 72.809344,60.551296 71.247616,62.931072 C69.4379947,65.7322667 68.533184,68.1492267 68.533184,70.181952 C68.533184,71.9419947 69.0289707,73.4045653 70.020544,74.569664 C71.061696,75.8091307 72.4622933,76.428864 74.222336,76.428864 Z M75.74688,73.379776 C72.9456853,73.379776 71.545088,72.003968 71.545088,69.252352 C71.545088,66.500736 72.6730027,63.7367253 74.928832,60.96032 C77.308608,58.059968 79.8495147,56.609792 82.551552,56.609792 C83.9893333,56.609792 85.1668267,56.981632 86.084032,57.725312 C87.0012373,58.468992 87.45984,59.547328 87.45984,60.96032 C87.45984,63.8110933 86.232768,66.5874987 83.778624,69.289536 C81.250112,72.0163627 78.572864,73.379776 75.74688,73.379776 Z" id="10" stroke="#2350A0" stroke-width="1.6" fill="#2350A0" fill-rule="nonzero"></path>),
		0: (<path d="M76.641824,76 C78.4018667,75.4546347 79.281888,74.5994027 79.281888,73.434304 C79.281888,72.6658347 78.5258133,71.0855147 77.013664,68.693344 C75.5015147,66.3011733 74.74544,64.8695893 74.74544,64.398592 C74.74544,63.580544 75.5882773,62.5146027 77.273952,61.200768 C79.4802027,59.5150933 81.0171413,58.3499947 81.884768,57.705472 C83.520864,56.441216 84.338912,55.3009067 84.338912,54.284544 C84.338912,53.1442347 84.004256,52.57408 83.334944,52.57408 L83.334944,52.57408 L77.53424,58.89536 C75.749408,60.828928 74.410784,61.795712 73.518368,61.795712 C72.997792,61.795712 72.291296,61.0396373 71.39888,59.527488 C70.28336,57.668288 69.4529173,56.2800853 68.907552,55.36288 C67.940768,53.8507307 67.0979307,53.094656 66.37904,53.094656 C65.932832,53.094656 65.579584,53.2743787 65.319296,53.633824 C65.059008,53.9932693 64.928864,54.4084907 64.928864,54.879488 C64.928864,55.3009067 65.3998613,56.0817707 66.341856,57.22208 C67.68048,58.8333867 68.535712,59.9117227 68.907552,60.457088 C69.8495467,61.795712 70.320544,62.9236267 70.320544,63.840832 C70.320544,64.510144 69.3599573,65.8921493 67.438784,67.986848 C65.5176107,70.0815467 64.2471573,71.128896 63.627424,71.128896 L63.627424,71.128896 L63.181216,71.054528 C62.5614827,71.4511573 62.251616,71.946944 62.251616,72.541888 C62.251616,73.9300907 62.549088,74.624192 63.144032,74.624192 C63.59024,74.624192 64.4206827,73.917696 65.63536,72.504704 C67.271456,70.5959253 68.3993707,69.269696 69.019104,68.526016 C70.2337813,67.113024 71.138592,66.406528 71.733536,66.406528 C72.5267947,66.406528 73.5059733,67.8071253 74.671072,70.60832 C75.2412267,71.9717333 75.898144,73.76896 76.641824,76 Z" id="X" stroke="#FFFFFF" stroke-width="1.6" fill="#FFFFFF" fill-rule="nonzero"></path>)
	}
	

	// Base SVG.
	return (
		<svg onClick={ animate } width="99px" height="99px" viewBox="0 0 99 99" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
			<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g id="HOME-maintenance-planner-1" transform="translate(-741.000000, -765.000000)" >
					<g id="Group-7" transform="translate(741.000000, 765.000000)">
						<animated.circle id="Oval-Copy-20" fill={props.fill} opacity={props.opacity} cx="49.5" cy="49.5" r="49.5" ></animated.circle>
						<path d="M76.0997626,76 L76.0997626,25.9882812 L67.1036688,25.9882812 L67.1036688,20 L65.1075751,20 L65.1075751,25.9882812 L31.0919501,25.9882812 L31.0919501,20 L29.0958563,20 L29.0958563,25.9882812 L20.0997626,25.9882812 L20.0997626,76 L76.0997626,76 Z M74.1036688,32.0039062 L22.0958563,32.0039062 L22.0958563,28.0117188 L29.0958563,28.0117188 L29.0958563,30.0078125 L31.0919501,30.0078125 L31.0919501,28.0117188 L65.1075751,28.0117188 L65.1075751,30.0078125 L67.1036688,30.0078125 L67.1036688,28.0117188 L74.1036688,28.0117188 L74.1036688,32.0039062 Z M74.1036688,74.0039062 L22.0958563,74.0039062 L22.0958563,34 L74.1036688,34 L74.1036688,74.0039062 Z M58.1075751,46.0039062 L58.1075751,37.9921875 L50.0958563,37.9921875 L50.0958563,46.0039062 L58.1075751,46.0039062 Z M46.1036688,46.0039062 L46.1036688,37.9921875 L38.0919501,37.9921875 L38.0919501,46.0039062 L46.1036688,46.0039062 Z M70.1114813,46.0039062 L70.1114813,37.9921875 L62.0997626,37.9921875 L62.0997626,46.0039062 L70.1114813,46.0039062 Z M44.1075751,44.0078125 L40.0880438,44.0078125 L40.0880438,39.9882812 L44.1075751,39.9882812 L44.1075751,44.0078125 Z M56.1114813,44.0078125 L52.0919501,44.0078125 L52.0919501,39.9882812 L56.1114813,39.9882812 L56.1114813,44.0078125 Z M68.0880438,44.0078125 L64.0958563,44.0078125 L64.0958563,39.9882812 L68.0880438,39.9882812 L68.0880438,44.0078125 Z M70.1114813,58.0078125 L70.1114813,49.9960938 L62.0997626,49.9960938 L62.0997626,58.0078125 L70.1114813,58.0078125 Z M46.1036688,58.0078125 L46.1036688,49.9960938 L38.0919501,49.9960938 L38.0919501,58.0078125 L46.1036688,58.0078125 Z M34.0997626,58.0078125 L34.0997626,49.9960938 L26.0880438,49.9960938 L26.0880438,58.0078125 L34.0997626,58.0078125 Z M58.1075751,58.0078125 L58.1075751,49.9960938 L50.0958563,49.9960938 L50.0958563,58.0078125 L58.1075751,58.0078125 Z M56.1114813,56.0117188 L52.0919501,56.0117188 L52.0919501,51.9921875 L56.1114813,51.9921875 L56.1114813,56.0117188 Z M68.0880438,56.0117188 L64.0958563,56.0117188 L64.0958563,51.9921875 L68.0880438,51.9921875 L68.0880438,56.0117188 Z M32.1036688,56.0117188 L28.1114813,56.0117188 L28.1114813,51.9921875 L32.1036688,51.9921875 L32.1036688,56.0117188 Z M44.1075751,56.0117188 L40.0880438,56.0117188 L40.0880438,51.9921875 L44.1075751,51.9921875 L44.1075751,56.0117188 Z M34.0997626,70.0117188 L34.0997626,62 L26.0880438,62 L26.0880438,70.0117188 L34.0997626,70.0117188 Z M58.1075751,70.0117188 L58.1075751,62 L50.0958563,62 L50.0958563,70.0117188 L58.1075751,70.0117188 Z M46.1036688,70.0117188 L46.1036688,62 L38.0919501,62 L38.0919501,70.0117188 L46.1036688,70.0117188 Z M56.1114813,67.9882812 L52.0919501,67.9882812 L52.0919501,63.9960938 L56.1114813,63.9960938 L56.1114813,67.9882812 Z M32.1036688,67.9882812 L28.1114813,67.9882812 L28.1114813,63.9960938 L32.1036688,63.9960938 L32.1036688,67.9882812 Z M44.1075751,67.9882812 L40.0880438,67.9882812 L40.0880438,63.9960938 L44.1075751,63.9960938 L44.1075751,67.9882812 Z" id="C" fill="#FFFFFF" fill-rule="nonzero"></path>
						{period == 0 ? (<circle id="Oval-Copy-17" fill="#E94C40" cx="72.5" cy="64" r="21"></circle>) : (<circle id="Oval-Copy-14" fill="#FFDF43" cx="71" cy="64" r="21"></circle>) }
						{numbers[period]}
					</g>
				</g>
			</g>
		</svg>
	)
}


const AnswerPanel = ( { nextStepCallback } ) => {

	const options = [
		{image: Button6Months, value: 6, friendlyValue: '6 months'},
		{image: Button12Months, value: 12, friendlyValue: '12 months'},
		{image: Button2Years, value: 24, friendlyValue: '2 years'},
		{image: Button5Years, value: 60, friendlyValue: '5 years'},
		{image: Button10Years, value: 120, friendlyValue: '10 years'},
	]
	return (
		<div>
			<Icons>
				{ options.map((option) => (
					<Icon onClick={ nextStepCallback } data-period={option.value}>
						<a href="#"><AnswerPanelButton period={option.value} /></a>
						<Text>In the last<br /> <YellowText>{ option.friendlyValue }</YellowText></Text>
					</Icon>
				))}

			
				<Icon onClick={ nextStepCallback } data-period={ 0 }>
					<a href="#"><AnswerPanelButton period={0} /></a>
					<Text>I've never<br /> done that</Text>
				</Icon>
			</Icons>

			<OutlineButton type="button" onClick={ nextStepCallback } data-period={-1}>Not applicable to my home</OutlineButton>
		</div>
	);

}


const ResultItem = ({question, answer}) => {

	let note = 'Unknown';
	let img = IconUnknown;
	let largeIcon = CrossImage;
	let mainText = question.upToDateText;
	if (answer > question.period || answer == 0) {
		img = IconOverdue;
		note = 'Overdue'
	// } else if (answer == 0) {
	// 	note = 'Unknown';
	// 	largeIcon = UnknownImage;
	// 	img = IconUnknown;
		mainText = question.overdueText;
	} else {
		note = 'Up-to-date!'
		largeIcon = TickImage;
		img = IconUpToDate;
	}

	let friendlyPeriod = question.period + ' months';
	if (question.period > 12) {
		friendlyPeriod = (question.period / 12) + ' years';
	}

	return (
		<ResultItemWrapper>
			<ResultImage src={ largeIcon } />
			<div>
				<TaskHeading>{ question.title }</TaskHeading>
				<TaskNote src={ img } />
				<Instructions>
					<Instruction>{ mainText}</Instruction>
					<Instruction><strong>Do it yourself?</strong>: <span dangerouslySetInnerHTML={{__html:  question.diyInstructions }} /></Instruction>
					<Instruction><strong>Hire a professional?</strong>: <span dangerouslySetInnerHTML={{__html: question.proInstructions }} /></Instruction>
				</Instructions>
			</div>
		</ResultItemWrapper>
	);
}





const ResultsPage = ({ questions, answers }) => {
	const shareId = encodeURIComponent(btoa(JSONCrush(JSON.stringify(answers))));

	const shareCallback = (e) => 
	{
		e.preventDefault();

		if (typeof window !== "undefined") {
			FB.ui({
				method: 'share',
				href: window.location + '?' + shareId,
				quote: `Find out how often you need to complete certain tasks in your house. Try Admiral's Home Maintenance planner and find how you score.`,
			}, function(response){ });
		}

	}

	const restartCallback = (e) => {
		e.preventDefault();

		window.location = window.location.href.split("?")[0];
	}

	useEffect(() => {

		if (typeof window !== "undefined" && typeof URLSearchParams !== 'undefined') {
			const urlParams = new URLSearchParams(window.location.search);

			if (!urlParams.has('q')) {

				const url = `${location.protocol}//${location.host}${location.pathname}?q=${shareId}`;
				history.pushState({}, 'Url', url);
			}
		}

	}, []);

	let filteredQuestions = questions.filter((item, index) => {
		return answers[index] < 0 ? false : true;
	});

	return (
		<ResultsPageWrapper>
			<HeadingWrapper>
				<Heading src={ HeaderResultsPage } />
			</HeadingWrapper>

			{filteredQuestions.length == 0 ? <p>You seem to have skipped all questions. Please try again.</p> : ''}
			{filteredQuestions.map((question, i) => (
				<ResultItem question={question} answer={answers[i]} />
			))}

			<ShareButton type="button" onClick={ shareCallback }>Share your results</ShareButton>
			<OutlineButton type="button" onClick={ restartCallback }>Start again</OutlineButton>
		</ResultsPageWrapper>
	)
}

const QuestionsPage = ({ step, nextStepCallback, goToStep }) => {

	const transitions = useTransition(step, null, {
		from: {  position: 'relative', transform: 'translate3d(100%, 0, 0)', opacity:1, width:'100%' },
		enter: { transform: 'translate3d(0%, 0, 0)' },
		leave: { transform: 'translate3d(-100%, 0, 0)', opacity: 0, 'position': 'absolute' },
	});


	return (
		<div>
			<HeadingWrapper>
				<Heading src={ HeaderHomepage } />
				<Progress currentStep={step} goToStep={goToStep} />
			</HeadingWrapper>
			<Question>
				{
					transitions.map(({ item, key, props }) =>
					(<animated.div key={key} style={props}>
						<ResultText>{step + 1}. { data[step].questionText }</ResultText>
					</animated.div>)
					)
				}
			</Question>

			<AnswerPanel nextStepCallback={ nextStepCallback } />
		</div>
	)
}


const App = ({ initialState }) => {

	const [step, setStep] = useState(initialState && initialState.step || 0);
	const [answers, setAnswers] = useState(initialState && initialState.answers || {});

	const nextStep = (e) => {
		e.preventDefault();
		let value = e.currentTarget.dataset.period;	
		setAnswers({ ...answers, [step]: value });
		setStep(step + 1);	
	}

	const goToStep = (e) => {
		let nextStep = parseInt(e.currentTarget.dataset.step);	

		if (nextStep < step) {
			setStep(step);
		}
	}

	const { y } = useSpring({
		to: { y: -25 },
		from: { y: -100 },
	  });

	const { yHouse } = useSpring({
		to: { yHouse: 0 },
		from: { yHouse: 100 },
	});


	return (
		<Wrapper>
			<GlobalStyle />

			<Container>
				<Header><Link href="https://admiral.com"><img src={LogoImage} /></Link></Header>
				<House>

					<Roof 
					style={{ transform: y.interpolate((y) => `translate3d(0, ${y}%, 0) scale(1.1)`) }}
					viewBox="0 0 885 265" version="1.1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" >
						<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
							<g id="HOME-maintenance-planner-1" transform="translate(-394.000000, -188.000000)">
								<g id="Group-2" transform="translate(418.000000, 215.625000)">
									<path d="M159,34.375 L219,34.375 C223.418278,34.375 227,37.956722 227,42.375 L227,98.5173957 C227,102.163878 224.534142,105.348948 221.003912,106.262351 L161.003912,121.786611 C156.726491,122.893341 152.361774,120.322988 151.255044,116.045567 C151.085698,115.391057 151,114.717719 151,114.041656 L151,42.375 C151,37.956722 154.581722,34.375 159,34.375 Z" id="Rectangle" fill="#FFDF43"></path>
									<polyline id="Line" stroke="#FFDF43" stroke-width="48" stroke-linecap="round" points="0 213.375 420.5 -1.42108547e-14 836.820312 213.375"></polyline>
								</g>
							</g>
						</g>
					</Roof>
					 
					<animated.div style={{ transform: yHouse.interpolate(y => `translate3d(0, ${y}%, 0)`) }}>
						<Triangle viewBox="0 0 761 226" preseveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">	
							<g id="Page-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
								<g id="HOME-maintenance-planner-2" transform="translate(-447.000000, -286.000000)" fill="#2350A0">
									<path d="M462.92993,468.404721 L827.5,286 L827.5,286 L1192.96438,468.85217 C1202.17961,473.462808 1208,482.88317 1208,493.187458 C1208,502.479907 1200.47993,510.019764 1191.18752,510.044185 L464.812481,511.953187 C455.00074,511.978973 447.025848,504.045889 447.000061,494.234148 C447.00002,494.218585 447,494.203021 447,494.187458 C447,483.270277 453.166588,473.289597 462.92993,468.404721 Z" id="Rectangle"></path>
								</g>
							</g>
						</Triangle>

						<InnerContent>
							<Page>
								{step >= data.length ? (
									<ResultsPage questions={ data } answers={ answers } />
								) : (
									<QuestionsPage goToStep={ goToStep } nextStepCallback={ nextStep } step={ step } />
								) }
							</Page>
						</InnerContent>
					</animated.div>

				</House>
			</Container>
		</Wrapper>
	);

}

export default App;
